import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button, Divider, Container, Grid, IconButton } from '@mui/material';
import moment from 'moment-timezone';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { db } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const LoanFormReadonly = ({ user, selectedEvent, isOpen, closeModal }) => {
  const [loanNumber, setLoanNumber] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [contribution, setContribution] = useState('');
  const [abogado, setAbogado] = useState('');

  useEffect(() => {
    const fetchAbogado = async (id) => {
      if (id) {
        const abogadoDoc = await getDoc(doc(db, 'abogados', id));
        if (abogadoDoc.exists()) {
          setAbogado(abogadoDoc.data().name);
        } else {
          setAbogado('No encontrado');
        }
      }
    };

    if (selectedEvent) {
      const { extendedProps, start } = selectedEvent;
      setLoanNumber(extendedProps.loanNumber || '');
      setClientName(extendedProps.clientName || '');
      setClientEmail(extendedProps.clientEmail || '');
      setContribution(extendedProps.contribution || '');
      setStartDate(moment(start).format('YYYY-MM-DD'));
      setStartTime(moment(start).format('HH:mm'));
      fetchAbogado(extendedProps.abogado);
    }
  }, [selectedEvent]);

  return (
    <Modal open={isOpen} onClose={closeModal}>
      <Container>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: 500 },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          overflowY: 'auto',
          maxHeight: '90vh'
        }}>
          <IconButton
            onClick={closeModal}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="h2" align="center" sx={{ mb: 3 }}>
            Detalles del Préstamo
            </Typography>

          <Grid container spacing={2}>
            <Grid item xs={6}><Typography><strong>Número de Préstamo:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{loanNumber}</Typography></Grid>

            <Divider sx={{ width: '100%', my: 1 }} />

            <Grid item xs={6}><Typography><strong>Cliente:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{clientName}</Typography></Grid>

            <Divider sx={{ width: '100%', my: 1 }} />

            <Grid item xs={6}><Typography><strong>Fecha:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{startDate}</Typography></Grid>

            <Divider sx={{ width: '100%', my: 1 }} />

            <Grid item xs={6}><Typography><strong>Hora:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{startTime}</Typography></Grid>

            <Divider sx={{ width: '100%', my: 1 }} />

            <Grid item xs={6}><Typography><strong>Aportación:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{contribution}</Typography></Grid>

            <Divider sx={{ width: '100%', my: 1 }} />

            <Grid item xs={6}><Typography><strong>Abogado:</strong></Typography></Grid>
            <Grid item xs={6}><Typography>{abogado}</Typography></Grid>
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            {user.role !== 'readonly' && (
              <Button startIcon={<EditIcon />} variant="contained">
                Editar
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    </Modal>
  );
};

export default LoanFormReadonly;